import React from 'react';
import styled from 'styled-components';
import { TOPBAR_HEIGHT } from 'SharedConstants/';
import { colourMasterLight } from 'Styles/colors.css';

const LoadingContainer = styled.div`
  position: absolute;
  top: ${TOPBAR_HEIGHT}px;
  display: flex;
  width: 100vw;
  height: calc(100vh - ${TOPBAR_HEIGHT}px);
  justify-content: center;
  align-items: center;
`;

const LoadingBackground = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${colourMasterLight};
  opacity: 0.95;
`;

const LoadingWrapper = styled.div`
  position: relative;
  margin-top: -40px;
  display: block;
  text-align: center;
`;

const LoadingMessage = styled.div`
  width: 220px;
  padding: 10px;
  text-align: center;
  font-size: 12px;
  opacity: 0.8;
`;

const ProgressContainer = styled.div`
  width: 220px;
  height: 3px;
  overflow: hidden;
`;

export const LoadingSpinner = () => (
  <LoadingContainer>
    <LoadingBackground />
    <LoadingWrapper>
      <LoadingMessage>Generating preview</LoadingMessage>
      <ProgressContainer>
        <div className="progress">
          <div className="progress-bar-indeterminate" />
        </div>
      </ProgressContainer>
    </LoadingWrapper>
  </LoadingContainer>);

export default LoadingSpinner;



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/components/LoadingSpinner/LoadingSpinner.jsx